/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import { connect } from "react-redux"
import React, { useState, useEffect } from "react"

import {
    Modal,
    ModalTitle,
    TitleSection,
    ContentSection,
    FooterSection,
    StepController,
    Step,
    Label,
    Row,
    Element,
    Button,
} from "trux"
import * as links from "../../../util/links"
import * as stat from "../../../util/analytics"

import * as playerActs from "../actions/players"
import SwapItem from "../components/SwapItem"
import { loadGame } from "../actions"

import "./ShowPlayer.css"

const SwapPlayerComponent = (props) => {
    const [traceNumber, setTraceNumber] = useState(props.toTraceNumber)

    useEffect(() => {
        stat.statPageView()
    }, [])

    useEffect(() => {
        console.log("SwapPlayerComponent", props.toTraceNumber, traceNumber)
        if (props.toTraceNumber && !traceNumber) {
            setTraceNumber(props.toTraceNumber)
        }
    }, [props.toTraceNumber])

    const playerName = () => {
        var name = "No Name"
        if (props.player.user) {
            name =
                props.player.user.first_name + " " + props.player.user.last_name
        }
        return name
    }

    const swapPlayer = () => {
        var player = null
        for (var i in props.allPlayers) {
            var p = props.allPlayers[i]
            var ptn = parseInt(p.default_trace_number, 10)
            if (ptn === traceNumber && p.user.is_dummy !== 1) {
                player = p
            }
        }
        console.log("swapPlayer", player)
        return player
    }

    const swapName = () => {
        var name = "No Name"
        var player = swapPlayer()
        if (player) {
            name = player.user.first_name + " " + player.user.last_name
        }
        return name
    }

    const playerTraceNumber = () => {
        var traceNumber = parseInt(props.player.default_trace_number, 10)
        if (traceNumber <= 0 || !traceNumber) {
            traceNumber = "?"
        }
        return traceNumber
    }

    const confirmTitle = () => {
        if (traceNumber > 0) {
            return (
                <Label marginBottom="4" marginTop="4">
                    Are you sure you want to move {playerName()} to Tracer{" "}
                    {traceNumber}?
                </Label>
            )
        } else {
            return (
                <Label marginBottom="4" marginTop="4">
                    Are you sure you want to remove {playerName()} from this
                    Tracer?
                </Label>
            )
        }
    }

    const close = (e) => {
        console.log("close", props.match.roster_type)
        if (e) {
            e.preventDefault()
        }

        if (props.match.params.roster_type) {
            // Roster App
            props.history.replace(
                `/${props.teamId}/rosters/${props.rosterType}/${props.rosterId}`
            )
        } else {
            // Video App
            let url = null
            if (props.match.params.trace_number) {
                url = links.gamePlayerDetailsUrl(
                    props.match.params.team_name,
                    props.match.params.playlist_id,
                    props.match.params.game_id,
                    props.match.params.event_number,
                    props.match.params.trace_number
                )
            }
            console.log("replacing url", url)
            props.history.replace(url)
        }
    }

    const swap = (e) => {
        e.preventDefault()
        var gameId = null
        if (props.rosterType === "games") {
            gameId = props.rosterId
        }
        props.doSwap(props.playerId, traceNumber, gameId, (success) => {
            if (success) {
                close()
                // simple hack to refresh rosters
                if (!props.match.params.roster_type) {
                    setTimeout(() => {
                        window.location.reload(true)
                    }, 200)
                } else {
                    if (gameId) props.loadGame(gameId)
                }
            } else {
                alert("Failed to swap player's tracer, please try again")
            }
        })
    }

    const onSwapTracerClicked = (num) => {
        setTraceNumber(num)
    }

    const isEmpty = (traceNumber) => {
        let val = true
        for (let i in props.allPlayers) {
            let p = props.allPlayers[i]
            if (parseInt(p.default_trace_number, 10) === traceNumber) {
                val = p.user.first_name.includes("Tracer")
                break
            }
        }
        return val
    }

    let title
    let btnTitle
    if (traceNumber && traceNumber <= 0) {
        title = `Remove ${props.player.user.first_name}?`
        btnTitle = "Yes, remove"
    } else {
        title = `Swap ${props.player.user.first_name}'s Tracer`
        btnTitle = "Yes, swap"
    }

    let step = "swap"
    if (traceNumber) {
        step = "confirm"
    }

    return (
        <Modal
            trkContext="Roster Swap Player"
            className="player-modal swap-player"
            onShadeClick={close}
            open={props.isLoggedIn === true}
        >
            <TitleSection onCloseClick={close}>
                <ModalTitle content={title} />
            </TitleSection>

            <ContentSection>
                <StepController step={step}>
                    <Step name="swap">
                        <Row>
                            {[...Array(20).keys()].map((index) => {
                                return (
                                    <SwapItem
                                        traceNumber={index + 1}
                                        current={
                                            props.player.default_trace_number
                                        }
                                        onClick={onSwapTracerClicked}
                                    />
                                )
                            })}
                        </Row>
                    </Step>

                    <Step name="confirm">
                        {traceNumber && traceNumber > 0 && (
                            <Element>
                                {confirmTitle()}
                                {swapPlayer && traceNumber > 0 && (
                                    <Label marginBottom="4">
                                        {swapName()} will be moved to Tracer{" "}
                                        {playerTraceNumber()}
                                    </Label>
                                )}
                            </Element>
                        )}
                        {traceNumber && traceNumber <= 0 && (
                            <Element>
                                {confirmTitle}
                                {traceNumber > 0 && (
                                    <Label marginBottom="4">
                                        Remove xxx from Trace #
                                        {playerTraceNumber()}
                                    </Label>
                                )}
                            </Element>
                        )}
                    </Step>
                </StepController>
            </ContentSection>
            <FooterSection>
                <StepController step={step}>
                    <Step name="confirm">
                        <Button
                            secondary
                            onClick={close}
                            content="Cancel"
                            className="SwapTracersButtons"
                        />
                        <Button
                            primary
                            onClick={swap}
                            content={btnTitle}
                            className="SwapTracersButtons"
                        />
                    </Step>
                </StepController>
            </FooterSection>
        </Modal>
    )
}

const mapStateToProps = (state, props) => {
    let teamId = ""
    let rosterType = "games"
    let rosterId = "2019"
    let playerId = ""
    let team = null
    let player = {
        default: true,
        default_trace_number: -1,
        user: { first_name: "", last_name: "", email: "" },
    }
    let isLoggedIn = false
    let allPlayers = []
    let toTraceNumber = 0

    // Team Id
    if (props.match.params.team) {
        teamId = props.match.params.team
    } else {
        teamId = props.match.params.team_name
    }

    // Roster Type
    if (props.match.params.roster_type) {
        rosterType = props.match.params.roster_type
    }

    // Roster Id
    if (rosterType !== "season") {
        if (props.match.params.roster_id) {
            rosterId = parseInt(props.match.params.roster_id, 10)
        } else {
            rosterId = parseInt(props.match.params.game_id, 10)
        }
    }

    // team
    team = state.team.value

    // player id
    if (props.match.params.player_id) {
        playerId = parseInt(props.match.params.player_id, 10)
    } else {
        playerId = parseInt(props.match.params.trace_number, 10)
    }

    // all players
    if (state.roster.value) {
        allPlayers = state.roster.value
    }

    // Player
    if (state.roster.value) {
        for (var i in state.roster.value) {
            if (state.roster.value[i].team_player_id === playerId) {
                player = state.roster.value[i]
                player.contacts = state.relations.value[player.user_id]
                break
            }
        }
        if (player.default === true) {
            for (i in state.roster.value) {
                if (
                    parseInt(state.roster.value[i].default_trace_number, 10) ===
                    playerId
                ) {
                    player = state.roster.value[i]
                    playerId = player.team_player_id
                    player.contacts = state.relations.value[player.user_id]
                    break
                }
            }
        }
    }

    // isLoggedIn
    isLoggedIn = state.isTeamLoggedIn

    // To trace number
    toTraceNumber = props.match.params.to_trace_number

    return {
        teamId,
        rosterType,
        rosterId,
        playerId,
        team,
        player,
        isLoggedIn,
        allPlayers,
        toTraceNumber,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        doSwap: (playerId, swapNumber, gameId, cb) => {
            dispatch(
                playerActs.swapPlayer(
                    playerId,
                    { default_trace_number: swapNumber },
                    gameId,
                    cb
                )
            )
        },
        loadGame: (gameId) => {
            dispatch(loadGame(gameId))
        },
    }
}

const SwapPlayer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SwapPlayerComponent)

export default SwapPlayer
